import {useState} from "react";

const FilterToggle = ({ options, defaultOption, onChange, selectedOption : passedSelected, optionToString=(x)=>x }) => {

    const [ selectedOption, setSelectedOption ] = useState(defaultOption);
    const setOption = passedSelected === undefined ? selectedOption : passedSelected;

    const getClassName = (option) => {
        if(option === setOption) {
            return "filter-toggle-item selected";
        } else {
            return "filter-toggle-item";
        }
    }

    const onClick = (option) => {
        if(onChange) onChange(option);
        setSelectedOption(option);
    }

    return (
        <div className="filter-toggle-container filter-item">
            <div className="filter-toggle">
                {options.map((option, index) => (
                    <div
                        className={getClassName(option)}
                        key={index}
                        onClick={() => onClick(option)}
                    >
                        {optionToString(option)}
                    </div>
                ))}
            </div>
        </div>
    )
}

export default FilterToggle;
